import { useRef, useState } from 'react';

import P from 'prop-types';

import { Api } from '../../../services/api';

export const AtribuirToken = ({ idCarga, updateCarga }) => {
  const inputToken = useRef();

  const [tokenSearch, setTokenSearch] = useState(null);

  const handleClickSearchToken = async () => {
    const id = inputToken.current.value;
    try {
      const token = await Api.get(`/token/${id}`);

      console.log(token);

      setTokenSearch(token.data);
      tokenSearch;
    } catch (e) {
      setTokenSearch(null);
    }
  };

  const handleClickAtribuirCarga = async () => {
    try {
      const id = inputToken.current.value;
      await Api.post(`/token/carga/${idCarga}`, {
        id,
      });

      alert('Carga atribuida com sucesso!');
      setTokenSearch(null);
      updateCarga(id);
      inputToken.current.value = '';
    } catch (e) {
      console.log(e.message);
    }
  };

  return (
    <div>
      <h5>Atribua um token para esta carga</h5>
      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Pesquise pelo número do token"
          aria-label="Pesquise pelo número do token"
          aria-describedby="button-addon2"
          ref={inputToken}
        />
        <button className="btn btn-outline-secondary" type="button" id="button-addon2" onClick={handleClickSearchToken}>
          Pesquisar
        </button>
      </div>
      <div>
        <table className="table mt-4">
          <thead>
            <tr>
              <th scope="col">Chave</th>
              <th scope="col">Motorista</th>
              <th scope="col">Transportadora</th>
              <th scope="col">Descrição</th>
              <th scope="col">-</th>
            </tr>
          </thead>
          <tbody>
            {tokenSearch ? (
              <tr key={tokenSearch.id}>
                <th scope="row">{tokenSearch.id}</th>
                <td>{tokenSearch.motorista}</td>
                <td>{tokenSearch.transportadora}</td>
                <td>{tokenSearch.descricao}</td>
                <td>
                  <button className="btn btn-success" onClick={handleClickAtribuirCarga}>
                    👍
                  </button>
                </td>
              </tr>
            ) : (
              <tr key={1}>
                <th scope="row">-</th>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>
                  <button className="btn btn-success" onClick={handleClickAtribuirCarga}>
                    -
                  </button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

AtribuirToken.propTypes = {
  idCarga: P.number,
  updateCarga: P.func,
};
